import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';

export function useModuleData<T = unknown>(siteId: string | undefined, moduleType: string) {
  return useQuery({
    queryKey: ['module-data', siteId, moduleType],
    queryFn: () => api<{ data: T | null }>(`/sites/${siteId}/modules/${moduleType}`),
    enabled: !!siteId,
  });
}

export function useUpdateModuleData(siteId: string, moduleType: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: unknown) =>
      api<{ ok: true }>(`/sites/${siteId}/modules/${moduleType}`, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['module-data', siteId, moduleType] });
      qc.invalidateQueries({ queryKey: ['sites'] });
    },
  });
}
